import React from "react";

import Form from "@Components/Form";
import { URLS, URGENCY_LEVEL_URL, STORAGE_CONSTANT } from "configs/constants";
import { getAssignedModule } from "../../../utils";

const initialValues = {
  // status: "",
  name: "",
  active: true,
};

const UrgencyLevelForm = () => {
  let formFields = [
    {
      type: "input",
      name: "name",
      label: "Name",
      required: true,
    },
  ];

  const formButtons = [
    {
      type: "submit",
      label: "Submit",
      color: "primary",
    },
    {
      type: "reset",
      label: "Reset",
    },
  ];

  let module = getAssignedModule(location.pathname);
  let actionPermission = false;
  if (!module || module === "") {
    actionPermission = true;
  } else {
    let updatedModules = JSON.parse(
      localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
    );
    if (updatedModules[module]) {
      let modulePermissions = updatedModules[module].map((perm) => {
        if (typeof perm === "string") {
          return perm.toLowerCase();
        }
        return perm;
      });
      if (modulePermissions.includes("change status")) {
        actionPermission = true;
      }
    }
  }
  if (actionPermission) {
    formFields.push({
      type: "switch",
      name: "active",
      label: "Active?",
      required: true,
      nolabel: "No",
      yeslabel: "Yes",
    });
  }

  return (
    <Form
      initialValues={initialValues}
      submitUrl={URGENCY_LEVEL_URL}
      listRoute={URLS.URGENCY_LEVEL_CUSTOM_FIELDS}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Urgency Level"
    />
  );
};

export default UrgencyLevelForm;
